import * as React from 'react';
import styled from '@emotion/styled';
export const PointTop = styled.circle`
		pointer-events: all;
	`;
export class BinaryLinkPointWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: false
    };
  }

  render() {
    const {
      point
    } = this.props;
    return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
      cx: point.getPosition().x,
      cy: point.getPosition().y,
      r: 5,
      fill: this.state.selected || this.props.point.isSelected() ? this.props.colorSelected : this.props.color
    }), /*#__PURE__*/React.createElement(PointTop, {
      className: "point",
      onMouseLeave: () => {
        this.setState({
          selected: false
        });
      },
      onMouseEnter: () => {
        this.setState({
          selected: true
        });
      },
      "data-id": point.getID(),
      "data-linkid": point.getLink().getID(),
      cx: point.getPosition().x,
      cy: point.getPosition().y,
      r: 15,
      opacity: 0.0
    }));
  }

}